import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import views from './views';
import transitions from './transitions';
import { setGformHoneypot, evalScripts } from './gravityforms';

export default class BarbaApp {
	constructor() {
		setGformHoneypot();

		this.scrollPos = [];
		this.pendingHash = null;

		if (history.scrollRestoration) {
			history.scrollRestoration = 'manual';
		}

		barba.hooks.before(({ current, next, trigger }) => {
			// Capture the originally requested hash here, before Barba resolves
			// the page request and overwrites next.url with the fetched response's
			// URL (which never carries a fragment, since XHR responseURL can't).
			this.pendingHash = next?.url?.hash || null;
		});

		barba.hooks.leave(({ current, next, trigger }) => {
			const leaveEvent = new CustomEvent('leave', {
				bubbles: true,
				detail: {
					current,
					next,
					trigger,
				},
			});

			document.dispatchEvent(leaveEvent);
		});

		barba.hooks.afterLeave(({ current, next, trigger }) => {
			//
		});

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			if (this.pendingHash && `#${this.pendingHash}` !== window.location.hash) {
				window.history.replaceState(window.history.state, '', `${next.url.path}#${this.pendingHash}`);
			}
			this.pendingHash = null;

			const blessEvent = new CustomEvent('bless', {
				bubbles: true,
				detail: {
					current,
					next,
					trigger,
				},
			});

			if (next.namespace === 'template-news' || next.namespace === 'template-press') {
				document.body.classList.add('header--light-blue');
			} else {
				document.body.classList.remove('header--light-blue');
			}

			if (next.namespace === 'template-team' || next.namespace === 'single-project') {
				document.body.classList.add('header--white');
			} else {
				document.body.classList.remove('header--white');
			}

			if (next.namespace === 'template-home') {
				document.body.classList.add('header--transparent');
			} else {
				document.body.classList.remove('header--transparent');
			}

			next.container.dispatchEvent(blessEvent);
		});

		barba.hooks.enter(({ current, next, trigger }) => {
			if (trigger !== 'back') {
				this.scrollPos.push({
					x: barba.history.current.scroll.x,
					y: barba.history.current.scroll.y,
				});
			}
		});

		barba.hooks.afterEnter(({ current, next, trigger }) => {
			if (trigger !== 'back') {
				if (!window.location.hash || !window.location.hash.startsWith('#vakprijs-')) {
					window.scrollTo(0, 0);
				}
			} else {
				window.scrollTo(...Object.values(this.scrollPos.pop()));
			}
		});

		barba.hooks.after(({ current, next, trigger }) => {
			evalScripts(next);

			document.body.setAttribute('tabindex', '-1');
			document.body.focus({ preventScroll: true });
		});

		barba.use(barbaPrefetch, {
			limit: 5,
		});

		barba.init({
			debug: window.WPDATA.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				const url = new URL(href);

				if (!url) {
					return false;
				}

				// Prevent external links
				if (url.hostname !== window.location.hostname) {
					return true;
				}

				// Prevent if not a /-link
				if (!url.pathname.endsWith('/')) {
					return true;
				}

				return false;
			},
			views,
			transitions,
		});
	}
}
